import { Subtitle } from "chq";
import secondsToTimeString from "./secondsToTimeString";

const updateSubtitlesText = (
  subtitles: Subtitle[],
  onUpdateSubtitles: (newData: any) => void
): Subtitle[] => {
  let isReady = true;
  const updatedSubtitles = subtitles.map(subtitle => {
    if (subtitle?.sections) {
      const newText = subtitle.sections.filter(section => !section.hidden).map(
        (section, index) => [
          index, `${secondsToTimeString(section.startTime)} --> ${secondsToTimeString(section.endTime)}`, section.text
        ].join("\n")
      ).join("\n\n");
      return { ...subtitle, text: `WEBVTT\n\n${newText}` };
    }
    isReady = false;
    return subtitle;
  });
  if (isReady) onUpdateSubtitles({ subtitles: updatedSubtitles });
  return updatedSubtitles;
};

export default updateSubtitlesText;
